(function () {
  'use strict';

  /* =========================
     Config — checkbox filter keys in sidebar order
  ========================== */
  var CHECKBOX_KEYS = [
    'em_brand',
    'em_boiler_type',
    'em_pump_type',
    'em_pressure_gauge',
    'em_group_type',
    'em_portafilter_size'
  ];

  /* =========================
     State
  ========================== */
  var cards = [];
  var matchingCards = [];
  var batchSize = 6;
  var visibleCount = 0;
  var activeFilters = {};

  /* =========================
     Init
  ========================== */
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.getElementById('cn-espresso-grid');
    if (!grid) return;

    batchSize = parseInt(grid.getAttribute('data-batch-size'), 10) || 6;
    cards = Array.from(grid.querySelectorAll('.cn-blog-listing__card'));

    // Build checkbox options from card data attributes
    buildFilterOptions();

    // Attach listeners (checkboxes exist now)
    attachCheckboxListeners();

    // Accordion: close others when one opens
    var groups = document.querySelectorAll('.cn-espresso-filter-group');
    for (var g = 0; g < groups.length; g++) {
      groups[g].addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        for (var h = 0; h < groups.length; h++) {
          if (groups[h] !== e.target) groups[h].removeAttribute('open');
        }
      });
    }

    // Toggle listeners
    var toggles = document.querySelectorAll('.cn-espresso-filter-toggle-input');
    for (var j = 0; j < toggles.length; j++) {
      toggles[j].addEventListener('change', onFilterChange);
    }

    // Load more
    var loadMoreBtn = document.getElementById('cn-espresso-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', onLoadMore);
    }

    // Mobile modal
    var filterBtn = document.getElementById('cn-espresso-filter-btn');
    var modalCloseBtn = document.getElementById('cn-espresso-modal-close');
    var modalApplyBtn = document.getElementById('cn-espresso-modal-apply');
    var modalClearBtn = document.getElementById('cn-espresso-modal-clear');
    var modalBackdrop = document.getElementById('cn-espresso-modal-backdrop');

    if (filterBtn) filterBtn.addEventListener('click', openModal);
    if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModal);
    if (modalApplyBtn) modalApplyBtn.addEventListener('click', closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
    if (modalClearBtn) modalClearBtn.addEventListener('click', function () {
      clearAllFilters();
      closeModal();
    });

    // First batch already visible from Liquid — init state
    matchingCards = cards.slice();
    visibleCount = Math.min(batchSize, cards.length);
    updateLoadMore();
    updateCount();
  });

  /* =========================
     Build filter checkboxes from card data
  ========================== */
  function buildFilterOptions() {
    CHECKBOX_KEYS.forEach(function (key) {
      var group = document.querySelector('[data-filter-key-group="' + key + '"]');
      if (!group) return;

      var ul = group.querySelector('.cn-espresso-filter-group__list');
      if (!ul) return;

      // Collect unique values, preserve original casing, sort alphabetically
      var seen = {};
      var uniqueVals = [];
      for (var i = 0; i < cards.length; i++) {
        var raw = (cards[i].getAttribute('data-' + key) || '').trim();
        if (!raw) continue;
        var lower = raw.toLowerCase();
        if (!seen[lower]) {
          seen[lower] = true;
          uniqueVals.push(raw);
        }
      }
      uniqueVals.sort(function (a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });

      // Hide accordion if no values found
      if (uniqueVals.length === 0) {
        group.style.display = 'none';
        return;
      }

      // Build checkbox items
      uniqueVals.forEach(function (val, index) {
        var id = 'cn-filter-' + key + '-' + index;
        var li = document.createElement('li');
        li.className = 'cn-espresso-filter-group__item';

        var label = document.createElement('label');
        label.className = 'cn-espresso-filter-check-label';
        label.setAttribute('for', id);

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.id = id;
        input.className = 'cn-espresso-filter-check';
        input.setAttribute('data-filter-key', key);
        input.value = val; // keep original casing; comparison is case-insensitive

        var box = document.createElement('span');
        box.className = 'cn-espresso-filter-check__box';
        box.setAttribute('aria-hidden', 'true');

        var text = document.createElement('span');
        text.className = 'cn-espresso-filter-check__text';
        text.textContent = val;

        label.appendChild(input);
        label.appendChild(box);
        label.appendChild(text);
        li.appendChild(label);
        ul.appendChild(li);
      });
    });
  }

  function attachCheckboxListeners() {
    var checkboxes = document.querySelectorAll('.cn-espresso-filter-check');
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].addEventListener('change', onFilterChange);
    }
  }

  /* =========================
     Mobile modal
  ========================== */
  function openModal() {
    var modal = document.getElementById('cn-espresso-modal');
    var btn = document.getElementById('cn-espresso-filter-btn');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.getElementById('cn-espresso-modal');
    var btn = document.getElementById('cn-espresso-filter-btn');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function clearAllFilters() {
    var checkboxes = document.querySelectorAll('.cn-espresso-filter-check:checked');
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = false;
    }
    var toggles = document.querySelectorAll('.cn-espresso-filter-toggle-input:checked');
    for (var j = 0; j < toggles.length; j++) {
      toggles[j].checked = false;
    }
    onFilterChange();
  }

  function updateFilterBtnCount() {
    var countEl = document.getElementById('cn-espresso-filter-btn-count');
    if (!countEl) return;
    var total = 0;
    var keys = Object.keys(activeFilters);
    for (var i = 0; i < keys.length; i++) {
      var val = activeFilters[keys[i]];
      total += (val === true) ? 1 : val.length;
    }
    if (total > 0) {
      countEl.textContent = total;
      countEl.classList.remove('hidden');
    } else {
      countEl.textContent = '';
      countEl.classList.add('hidden');
    }
  }

  /* =========================
     Filter change
  ========================== */
  function onFilterChange() {
    collectActiveFilters();
    applyFilters();
    updateFilterBtnCount();
  }

  function collectActiveFilters() {
    activeFilters = {};

    var checked = document.querySelectorAll('.cn-espresso-filter-check:checked');
    for (var i = 0; i < checked.length; i++) {
      var key = checked[i].getAttribute('data-filter-key');
      var val = checked[i].value.toLowerCase(); // normalise for comparison
      if (!activeFilters[key]) activeFilters[key] = [];
      activeFilters[key].push(val);
    }

    var activeToggles = document.querySelectorAll('.cn-espresso-filter-toggle-input:checked');
    for (var j = 0; j < activeToggles.length; j++) {
      var tKey = activeToggles[j].getAttribute('data-filter-key');
      activeFilters[tKey] = true;
    }

    updateAccordionCounts();
  }

  /* =========================
     Apply filters
  ========================== */
  function applyFilters() {
    var filterKeys = Object.keys(activeFilters);

    matchingCards = cards.filter(function (card) {
      for (var i = 0; i < filterKeys.length; i++) {
        var key = filterKeys[i];
        var cardVal = (card.getAttribute('data-' + key) || '').toLowerCase().trim();
        var filterVal = activeFilters[key];

        if (filterVal === true) {
          // Toggle: boolean metafield must be "true"
          if (cardVal !== 'true') return false;
        } else {
          // Checkbox: case-insensitive match against selected values
          var matched = false;
          for (var k = 0; k < filterVal.length; k++) {
            if (cardVal === filterVal[k]) {
              matched = true;
              break;
            }
          }
          if (!matched) return false;
        }
      }
      return true;
    });

    // Hide all
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.display = 'none';
    }

    // Show first batch
    visibleCount = 0;
    showBatch();

    updateCount();
    updateLoadMore();
    updateChips();
    updateNoResults();
  }

  /* =========================
     Batch reveal
  ========================== */
  function showBatch() {
    var end = Math.min(visibleCount + batchSize, matchingCards.length);
    for (var i = visibleCount; i < end; i++) {
      matchingCards[i].style.display = '';
    }
    visibleCount = end;
  }

  function onLoadMore() {
    showBatch();
    updateLoadMore();
  }

  /* =========================
     UI updates
  ========================== */
  function updateLoadMore() {
    var btn = document.getElementById('cn-espresso-load-more');
    if (!btn) return;
    btn.style.display = visibleCount >= matchingCards.length ? 'none' : '';
  }

  function updateCount() {
    var el = document.getElementById('cn-espresso-count');
    if (el) el.textContent = matchingCards.length;
  }

  function updateNoResults() {
    var el = document.getElementById('cn-espresso-no-results');
    if (!el) return;
    el.style.display = matchingCards.length === 0 ? '' : 'none';
  }

  function updateAccordionCounts() {
    var countEls = document.querySelectorAll('[data-count-for]');
    for (var i = 0; i < countEls.length; i++) {
      var key = countEls[i].getAttribute('data-count-for');
      var val = activeFilters[key];
      var count = !val ? 0 : (val === true ? 1 : val.length);
      if (count > 0) {
        countEls[i].textContent = '(' + count + ')';
        countEls[i].classList.remove('hidden');
      } else {
        countEls[i].textContent = '';
        countEls[i].classList.add('hidden');
      }
    }
  }

  /* =========================
     Active chips
  ========================== */
  function updateChips() {
    var container = document.getElementById('cn-espresso-chips');
    if (!container) return;
    container.innerHTML = '';

    var filterKeys = Object.keys(activeFilters);
    for (var i = 0; i < filterKeys.length; i++) {
      var key = filterKeys[i];
      var filterEl = document.querySelector('[data-filter-key-group="' + key + '"]');
      var groupLabel = filterEl ? filterEl.getAttribute('data-filter-label') : key;
      var val = activeFilters[key];

      if (val === true) {
        container.appendChild(makeChip(groupLabel, key, null));
      } else {
        for (var j = 0; j < val.length; j++) {
          // Find the original-cased value by matching this specific lowercase value
          var cbs = document.querySelectorAll('.cn-espresso-filter-check[data-filter-key="' + key + '"]');
          var displayVal = val[j];
          for (var k = 0; k < cbs.length; k++) {
            if (cbs[k].value.toLowerCase() === val[j]) {
              displayVal = cbs[k].value;
              break;
            }
          }
          container.appendChild(makeChip(groupLabel + ': ' + displayVal, key, val[j]));
        }
      }
    }
  }

  function makeChip(label, filterKey, filterValue) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cn-espresso-chip';
    btn.setAttribute('aria-label', 'Remove filter: ' + label);

    var inner = document.createElement('span');
    inner.className = 'cn-espresso-chip__inner';
    inner.textContent = label + ' ';

    var close = document.createElement('span');
    close.className = 'cn-espresso-chip__remove';
    close.setAttribute('aria-hidden', 'true');
    close.innerHTML = '&times;';
    inner.appendChild(close);
    btn.appendChild(inner);

    btn.addEventListener('click', function () {
      removeFilter(filterKey, filterValue);
    });

    return btn;
  }

  function removeFilter(key, value) {
    if (value === null) {
      var toggle = document.querySelector('.cn-espresso-filter-toggle-input[data-filter-key="' + key + '"]');
      if (toggle) toggle.checked = false;
    } else {
      // Match by lowercase since filter values are stored lowercase
      var cbs = document.querySelectorAll('.cn-espresso-filter-check[data-filter-key="' + key + '"]');
      for (var i = 0; i < cbs.length; i++) {
        if (cbs[i].value.toLowerCase() === value) {
          cbs[i].checked = false;
          break;
        }
      }
    }
    onFilterChange();
  }

})();
